import VueCurrencyFilter from "vue-currency-filter";

const options = {
    symbol: "€",
    thousandsSeparator: ".",
    symbolSpacing: true
};

Vue.use(VueCurrencyFilter, [
    {
        ...options,
        symbolPosition: "end",
    },
    {
        name: "currency_symbol_front",
        symbolPosition: "end",
        ...options,
    }
]);
